import { useState } from "react";

import List from "@material-ui/core/List";

import CollapsedComponentOffer from "./CollapsedComponentOffer";

import ListingItem from "../../LisingItem";
import ShowContentBasedOnDecision from "./ShowContentBasedOnDecision";
import {
  getOfferStyle,
  getRejectReasonText,
  showCurrencyIfSet,
} from "./helper";
import { dateTimeFormater } from "../../../../../utilities/formaters";

const CreditOfferExpanded = ({ offerWithDecision }) => {
  const [collapsed, setCollapsed] = useState(false);

  const warningStyle = { color: "tomato" };

  if (!collapsed)
    return (
      <CollapsedComponentOffer
        {...{ offerWithDecision, collapsed, setCollapsed }}
      />
    );

  return (
    <List style={getOfferStyle(offerWithDecision)}>
      <div
        onClick={setCollapsed.bind(this, collapsed !== true)}
        style={{ color: "black", marginLeft: "2px" }}
      >
        Collapse
      </div>

      <ListingItem
        primaryText={showCurrencyIfSet(offerWithDecision.PayoutAmount)}
        secondaryText="Payout Amount"
      />

      <ListingItem
        primaryText={showCurrencyIfSet(offerWithDecision.InitFee)}
        secondaryText="Init fee"
      />

      <ListingItem
        primaryText={
          offerWithDecision.IsSigned ? (
            "Yes"
          ) : (
            <span style={warningStyle}>No</span>
          )
        }
        secondaryText="Signed"
      />

      <ListingItem
        primaryText={
          offerWithDecision.ExpiredAt ? (
            <span style={warningStyle}>
              {dateTimeFormater(offerWithDecision.ExpiredAt)}
            </span>
          ) : (
            "No"
          )
        }
        secondaryText="Expired"
      />

      <ListingItem
        primaryText={
          offerWithDecision.LoanTerm ? offerWithDecision.LoanTerm : "not set"
        }
        secondaryText="Loan term"
      />

      <ListingItem
        primaryText={
          offerWithDecision.NominalInterest
            ? Math.round(offerWithDecision.NominalInterest * 100 * 100) / 100 +
              "%"
            : "not set"
        }
        secondaryText="Nominal interest"
      />

      <ListingItem
        primaryText={
          offerWithDecision.EffectiveInterest
            ? Math.round(offerWithDecision.EffectiveInterest * 100 * 100) /
                100 +
              "%"
            : "not set"
        }
        secondaryText="Effective interest"
      />

      <ListingItem
        primaryText={showCurrencyIfSet(offerWithDecision.Annuity)}
        secondaryText="Annuity"
      />

      <ListingItem
        primaryText={showCurrencyIfSet(offerWithDecision.InvoiceFee)}
        secondaryText="Admin fee"
      />

      <ListingItem
        primaryText={getRejectReasonText(offerWithDecision)}
        secondaryText="Reject reason"
      />

      <ShowContentBasedOnDecision {...{ offerWithDecision }} />
    </List>
  );
};

export default CreditOfferExpanded;
